import React from "react";
import { Button } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { YhAuth } from "@/components/auth/YhAuth";
import { useAllocModel } from "../inventoryStatisticsModel";

export const DataBox = () => {
    const { exportAlloc } = useAllocModel();

    const action = <>
        <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={() => exportAlloc()}
        >导出</Button>
    </>;

    return (
        <YhBox action={action} style={{ height: 'calc(100vh - 180px)' }}>
            <DataTable />
        </YhBox>
    )
}